export default __webpack_public_path__ + "static/fall19-4ff641aabe0554973815c2a6b8543123.webp";